// src/utils/helpers.js - Updated with better currency formatting

export const formatDate = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(new Date(date));
};

export const formatTime = (time) => {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
};

export const formatCurrency = (amount, currency = 'EUR', currencySymbol = null) => {
  if (amount === null || amount === undefined) return '-';
  
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '-';
  
  // If currency is an object (from API), use its properties
  if (typeof currency === 'object' && currency !== null) {
    const symbol = currency.symbol || '$';
    const decimals = currency.minorUnit || 2;
    return `${symbol}${numAmount.toFixed(decimals)}`;
  }
  
  // If we have a currency symbol provided separately
  if (currencySymbol) {
    return `${currencySymbol}${numAmount.toFixed(2)}`;
  }
  
  // Fallback to currency code
  const currencySymbols = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'LKR': 'Rs.',
  };
  
  const symbol = currencySymbols[currency] || currency + ' ';
  return `${symbol}${numAmount.toFixed(2)}`;
};

export const generateBookingCode = () => {
  const now = new Date();
  const year = String(now.getFullYear()).slice(-2);
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const dateStr = `${year}${month}${day}`;
  
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let suffix = '';
  for (let i = 0; i < 4; i++) {
    suffix += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return `LKW-${dateStr}-${suffix}`;
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone, countryCode = '+94', countryCodes = []) => {
  const digits = phone.replace(/\D/g, '');
  const country = countryCodes.find(c => c.code === countryCode);
  
  if (country) {
    return digits.length >= country.minLength && digits.length <= country.maxLength;
  }
  // Default: accept 7-12 digits
  return digits.length >= 7 && digits.length <= 12;
};

export const getVehicleBadge = (className) => {
  switch (className) {
    case 'Economy':
      return { text: 'BEST VALUE', color: 'bg-green-500' };
    case 'Standard':
      return { text: 'MOST POPULAR', color: 'bg-red-500' };
    default:
      return null;
  }
};

export const formatPhoneDisplay = (phone) => {
  if (!phone) return 'N/A';
  
  // Remove all non-digits except +
  const cleaned = phone.replace(/[^\d+]/g, '');
  
  // Format based on length and country code
  if (cleaned.startsWith('+94')) {
    // Sri Lanka: +94 77 264 1670
    const number = cleaned.slice(3);
    return `+94 ${number.slice(0, 2)} ${number.slice(2, 5)} ${number.slice(5)}`;
  } else if (cleaned.startsWith('+1')) {
    // USA/Canada: +1 234 567 8901
    const number = cleaned.slice(2);
    return `+1 ${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6)}`;
  } else if (cleaned.startsWith('+44')) {
    // UK: +44 7911 123456
    const number = cleaned.slice(3);
    return `+44 ${number.slice(0, 4)} ${number.slice(4)}`;
  } else if (cleaned.startsWith('+')) {
    // Generic international: split into groups of 3-4
    const countryCode = cleaned.match(/^\+\d{1,3}/)?.[0] || '';
    const number = cleaned.slice(countryCode.length);
    const formatted = number.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    return `${countryCode} ${formatted}`;
  }
  
  // Local number: group by 3s
  return cleaned.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
};